import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'
import Icon from './styles/icon';
import { connect } from 'react-redux'
import { Container, Row, Col, Card, CardImg, CardHeader } from 'reactstrap';
import store from './redux/store/index'
import HttpClient from './myapi'
import './styles/cart.css'
import { RemoveFromCart } from './redux/actions/index'

const _webserver = HttpClient.WebServerGallery;



export default class Cart extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            cartEmpty: true
        }
    }

    render() {
        return (
            <div>
                <a href="tel:8855998600">
                <div className="call-us">
                    <p><Icon icon="fa-phone" /></p>
                    Call Us
                    <p> 8855998600</p>
                </div>
                </a>
                <div className="blank-page">

                    <h1 className="page-heading">Shopping Cart</h1>

                    <MyCart />
                </div>
            </div>
        )
    }
}
const map1 = state => {
    return { cart: state.cart }
}

const MyCart1 = props => (
    <div>
        {
            props.cart.length
                ? <FullCart sarees={props.cart} />
                : <Empty />
        }
    </div>
)

const removeItem = (id) => {
    store.dispatch(RemoveFromCart(id))
}
const MyCart = connect(map1)(MyCart1)

const FullCart = (props) => {
    let store1 = store.getState();
    const allImgs = store1.allImgs;
    const selected = [];
    let tmp = props.sarees;
    allImgs.forEach(sari => {
        tmp.forEach(selImg => {
            if (sari.id === selImg) {
                selected.push(sari)
                // tmp.splice(0, 1)
            }
        });
    });

    return (
        <Container>
            <Row>
                {
                    selected.map((sari, ind) => (
                        <Col key={ind} xs={12} sm={6} md={6}>
                            <Card>
                                <CardHeader className="v-card-header">
                                    Product Id: #{sari.id}
                                    &nbsp; &nbsp; &#8377;{sari.sprice}
                                    <span className="card-header-button" onClick={() => removeItem(sari.id)}>
                                        <span>Remove </span>
                                        <Icon icon="fa-times" />
                                    </span>
                                </CardHeader>
                                <CardImg top width="100%" src={_webserver + sari.srcnm} />
                            </Card>
                        </Col>
                    ))
                }
            </Row>
        </Container>
    )
}

const Empty = () => (
    <div className="text-center">
        <Link to="/gallery">
            <Button className="card-btn">View Sarees</Button>
        </Link>
        <div>
        </div>
        <Icon icon="fa-cart-arrow-down placeholder-icon" />
    </div>
)


// WEBPACK FOOTER //
// ./src/Cart.jsx